import { render, staticRenderFns } from "./DataCellIcon.vue?vue&type=template&id=351219f4&"
import script from "./DataCellIcon.vue?vue&type=script&lang=js&"
export * from "./DataCellIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports